import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface IncreaseRatingTipsSectionProps {
  tips: string[];
}
export function IncreaseRatingTipsSection(props: IncreaseRatingTipsSectionProps) {
  const { tips } = props;
  return (
    <Stack spacing={4}>
      <Text semibold variant="h4">
        Tips to ace this rating
      </Text>
      <Stack spacing={4}>
        {tips.map((tip) => (
          <Stack key={tip} direction="row" alignItems="top" gap={2}>
            <CbhIcon
              type="diamond"
              size="small"
              sx={{ color: (theme) => theme.palette.tiers?.gold.text }}
            />
            <Text variant="body1">{tip}</Text>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
